import 'projects/sharedComponents/src/pet/careResources/products/careResourcesProduct.scss';

import { HeapCategory, HeapMetadata } from 'clientServerShared/types/eventTracking';
import { Link, Typography } from '@mui/material';

import { CareResourcesProductFragment } from 'projects/sharedComponents/src/generated/contentful-graphql-types';
import { FC } from 'react';
import { PersonalizedVariableContentFragment } from 'projects/sharedComponents/src/generated/graphql-client-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { getContentfulProductFullName } from 'projects/sharedComponents/src/pet/careResources/products/getContentfulProductFullName';
import { getHeapDataAttributes } from 'projects/sharedComponents/src/services/eventTracking/eventTracking';
import { richTextDefaultOptions } from 'projects/sharedComponents/src/pet/careResources/contentful/richTextDefaultOptions';

export type CareResourcesProductProps = {
  pet: PersonalizedVariableContentFragment;
  product: CareResourcesProductFragment;
} & Pick<HeapMetadata, 'heapValue'>;

export const CareResourcesProduct: FC<CareResourcesProductProps> = (props) => {
  const { product, pet, heapValue } = props;

  const fullProductName = getContentfulProductFullName(product);

  return (
    <Link
      href={product.url ?? ''}
      className="careResourcesProduct"
      rel="noopener"
      target="_blank"
      {...getHeapDataAttributes({
        heapCategory: HeapCategory.CARE_RESOURCES,
        heapAction: 'Click Care Resources Product - Carousel',
        heapDetails: fullProductName,
        heapValue,
      })}
    >
      {/* Product image if we have one. If we do not have one just take up space anyways. */}
      <div className="careResourcesProduct-imageContainer">
        <div className="careResourcesProduct-imageBorder">
          {product.productImage && product.productImage.url && (
            <img className="careResourcesProduct-image" src={product.productImage.url} alt="" />
          )}
        </div>
      </div>

      {/* The text, price, and link to buy the product. */}
      <div className="careResourcesProduct-productInfoContainer">
        <div className="careResourcesProduct-title">
          <Typography variant="body1">
            <b className="careResourcesProduct-productName">{fullProductName}</b>
          </Typography>
        </div>

        {!!product.productDescription && (
          <div className="careResourcesProduct-description">
            {documentToReactComponents(product.productDescription.json, richTextDefaultOptions(pet))}
          </div>
        )}

        {!!product.price && (
          <div className="careResourcesProduct-price">
            <Typography variant="body2">
              <b>${product.price}</b>
            </Typography>
          </div>
        )}
      </div>
    </Link>
  );
};
